import React from "react";

export const inputCls = "mt-2 bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] focus:border-[#D4AF37] rounded-sm px-3 py-2 w-full outline-none text-sm";
export const btnPrimary = "bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] disabled:opacity-50 transition-colors font-bold rounded-sm px-5 py-2 text-sm";
export const btnSecondary = "border border-[#35353B] text-[#F5F3ED] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors rounded-sm px-4 py-2 text-sm";

export function Field({ label, children, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">{label}</span>
      {children}
    </label>
  );
}

export function Panel({ title, children, testId }) {
  return (
    <div data-testid={testId} className="bg-[#202127] border border-[#35353B] rounded-lg p-6 mb-6">
      {title && <h2 className="text-xl font-bold text-[#F5F3ED] mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>{title}</h2>}
      {children}
    </div>
  );
}

export function ActiveBadge({ active }) {
  return (
    <span className={`inline-block px-2 py-0.5 border rounded-sm text-xs ${active ? "text-[#35C78A] border-[#35C78A]" : "text-[#F06464] border-[#F06464]"}`}>
      {active ? "Aktif" : "Nonaktif"}
    </span>
  );
}

export function FormActions({ editing, onCancel, saving, testPrefix }) {
  return (
    <div className="flex gap-2 items-end">
      <button data-testid={`${testPrefix}-save-btn`} type="submit" disabled={saving} className={btnPrimary}>
        {editing ? "Simpan Perubahan" : "Tambah"}
      </button>
      {editing && <button data-testid={`${testPrefix}-cancel-btn`} type="button" onClick={onCancel} className={btnSecondary}>Batal</button>}
    </div>
  );
}

export const errMsg = (err) => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || "Gagal menyimpan";
};
